import React from "react";
import { connect } from "react-redux";
import { Tabs } from "antd";
import PropTypes, { string } from 'prop-types';
import { TabsWrap, IconPadding, DataExportPrint } from "./styles";
import CommonTabContent from "./../../Components/CommonTabContent/CommonTabContent.js";
import CommonTabContentPrint from "./../../Components/CommonTabContent/CommonTabContentPrint.js";
import { tabChangerHandler, fetchTransactionalTabDetails } from './../../Pages/actions';
import { getTransactionApi } from "./../../Pages/config";
import { tabNameHandler } from "./../../Pages/txnUitls";
import ExportContent from "./ExportContent";
import { initiateTracking } from "./../../../../utils/commonUtil";
import { exportExcelTableData } from "../../../../services/apiServices";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import PrintComponents from "react-print-components";
import printIcon from "../../../../assets/icons/print.svg";
import { StyleLessButton } from "../../../../CommonComponents/commonStyles";

const TabPane = Tabs.TabPane;

const TabsComponent = props => {

  const handleChange = activeKey => {
    props.tabChangerHandler(activeKey);
    const tabName = tabNameHandler(activeKey);
    initiateTracking('tabClick', props.pageTitle, '', tabName.analytics);
    if (!(props.tabTransactionalData[tabName.apiType] && props.tabTransactionalData[tabName.apiType].fetchedData)) {
      let apiData = {
        startDate: props.filterMinDate,
        endDate: props.filterMaxDate,
        isTradeDate: !(props.radioValue[tabName.tabType] === 'enteredDate'),
        type: tabName.apiType,
        selectedVal: props.selectedVal
      };
      props.fetchTransactionalTabDetailsData(getTransactionApi(apiData));
    }
  };

  const exportAccountBalanceHistory = () => {
    const tabNameMapper = {
      "1": { tabName: "AllTransactions", fileName: "All Transactions Detail", tabIdentfier: "all"},
      "2": { tabName: "Contributions", fileName: "Contributions Detail", tabIdentfier: "contributions"},
      "3": { tabName: "Grants", fileName: "Grants Detail", tabIdentfier: "grants"},
      "4": { tabName: "Exchanges", fileName: "Exchange Detail", tabIdentfier: "exchanges"},
      "5": { tabName: "OtherTransactions", fileName: "Other Transactions Detail", tabIdentfier: "otherTransactions"}
    }

    const tabkey = tabNameMapper[props.activeTabKey].tabName;
    const filename = tabNameMapper[props.activeTabKey].fileName;
    const tabIdentifier = tabNameMapper[props.activeTabKey].tabIdentfier;
    let txndata = props.txnExportData[tabkey];
    let exportData = Array.isArray(txndata) ? txndata.find(o => o.tab === tabkey): txndata;
    let url = `/donor-portal/api/account/${getPrimaryAccount().userId}/exportTransactionSummary`;
    return exportExcelTableData(url, { tab: tabIdentifier, transactions: exportData.data }, filename);
  }

  const PrintText = props => {
    return (
      <DataExportPrint>
        <a id="anrPrint">
          {props.children}
        </a>
      </DataExportPrint>
    );
  };
  return (
    <TabsWrap data-test="transaction-tabs-component">
      <Tabs type="card" activeKey={props.activeTabKey} onChange={handleChange}
        tabBarExtraContent={<div className="extra-feature-component"><ExportContent   pageTitle={props.pageTitle} activeKey={props.activeTabKey} onClick={exportAccountBalanceHistory}/>
        <PrintComponents
                    className="i_print"
                    trigger={
                      <StyleLessButton id="btnPrint">
                        <IconPadding className="ml2">
                          <img src={printIcon} alt="print ico"/>
                          <PrintText>PRINT</PrintText>
                        </IconPadding>
                      </StyleLessButton>
                    }
                  >
                      <div>
                      {props.activeTabKey.toString() === "1" ? (
                        <CommonTabContentPrint tabType="AllTransactions"/>
                      ) : (
                        <>
                          {props.activeTabKey.toString() === "2" && (
                            <CommonTabContentPrint tabType="Contributions"/>
                          )}
                          {props.activeTabKey.toString() === "3" && (
                            <CommonTabContentPrint tabType="Grants"/>
                          )}

                           {props.activeTabKey.toString() === "4" && (
                             <CommonTabContentPrint tabType="Exchanges" />
                          )}
                           {props.activeTabKey.toString() === "5" && (
                            <CommonTabContentPrint tabType="OtherTransactions" />
                          )}
                        </>
                      )}
                    </div>
                  </PrintComponents></div>}>

        <TabPane tab="All transactions" key="1" tabIndex="1">
          <CommonTabContent tabType="AllTransactions"
            pageTitle={props.pageTitle}
            radioChange={props.radioChange}
            radioValue={props.radioValue}
            selectedVal={props.selectedVal}
            filterMaxDate={props.filterMaxDate}
            filterMinDate={props.filterMinDate} />
        </TabPane>
        <TabPane tab="Contributions" tabIndex="2" key="2">
          <CommonTabContent tabType="Contributions"
            pageTitle={props.pageTitle}
            radioChange={props.radioChange}
            radioValue={props.radioValue}
            selectedVal={props.selectedVal}
            filterMaxDate={props.filterMaxDate}
            filterMinDate={props.filterMinDate} />
        </TabPane>
        <TabPane tab="Grants" key="3" tabIndex="3">
          <CommonTabContent tabType="Grants"
            pageTitle={props.pageTitle}
            radioChange={props.radioChange}
            radioValue={props.radioValue}
            selectedVal={props.selectedVal}
            filterMaxDate={props.filterMaxDate}
            filterMinDate={props.filterMinDate} />
        </TabPane>
        <TabPane tab="Exchanges" key="4" tabIndex="4">
          <CommonTabContent tabType="Exchanges"
            pageTitle={props.pageTitle}
            radioChange={props.radioChange}
            radioValue={props.radioValue}
            selectedVal={props.selectedVal}
            filterMaxDate={props.filterMaxDate}
            filterMinDate={props.filterMinDate} />
        </TabPane>
        <TabPane tab="Other transactions" key="5" tabIndex="5">
          <CommonTabContent tabType="OtherTransactions"
            pageTitle={props.pageTitle}
            radioChange={props.radioChange}
            radioValue={props.radioValue}
            selectedVal={props.selectedVal}
            filterMaxDate={props.filterMaxDate}
            filterMinDate={props.filterMinDate} />
        </TabPane>
        
      </Tabs>
    </TabsWrap>
  );
};

TabsComponent.propTypes = {
  filterMaxDate: PropTypes.string,
  filterMinDate: PropTypes.string,
  selectedVal: PropTypes.arrayOf(PropTypes.string),
  radioValue: PropTypes.object,
  radioChange: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  filterData: state.getIn(["transactionSummary", "filterData", "data"]),
  content: state.getIn(["transactionSummary", "transactionalDetails", "data"]),
  tabTransactionalData: state.getIn(["transactionSummary", "tabTransactionalData"]),
  activeTabKey: state.getIn(["transactionSummary", "activeTabKey"]),
  txnExportData: state.getIn(["transactionSummary", "txnExportData"]).toJS()
});

const mapDispatchToProps = dispatch => ({
  tabChangerHandler: (key) => dispatch(tabChangerHandler(key)),
  fetchTransactionalTabDetailsData: data => dispatch(fetchTransactionalTabDetails(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TabsComponent);